import { render, staticRenderFns } from "./event-capture.vue?vue&type=template&id=616ea59b&scoped=true&"
import script from "./event-capture.vue?vue&type=script&lang=js&"
export * from "./event-capture.vue?vue&type=script&lang=js&"
import style0 from "./event-capture.vue?vue&type=style&index=0&id=616ea59b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ea59b",
  null
  
)

component.options.__file = "event-capture.vue"
export default component.exports